// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"b3c0df31","418":"b3c0df31"}[chunkId] + ".chunk.css";
};